import React, { ReactNode, useContext } from "react";
import { useAuth } from "../components/auth/ParseAuthContext.tsx";
import { Currency, CurrencyCode, gbp, getCurrency } from "../i18n/Currency";

interface CurrencyContextProps {
  currency: Currency;
  switchCurrency: (code: CurrencyCode) => void;
}

export const CurrencyContext = React.createContext<CurrencyContextProps>({
  currency: gbp,
  switchCurrency: () => {},
});

// provides the case context based on case loaded by react-router's loader
export const CurrencyContextProvider = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}) => {
  const { auth, updateUserField } = useAuth();

  return (
    <CurrencyContext.Provider
      value={{
        currency: getCurrency(
          auth.kind === "signedIn" ? auth.user.currencyCode : undefined,
        ),
        switchCurrency: (code) => updateUserField("currencyCode", code),
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export function useCurrency() {
  const context = useContext(CurrencyContext);
  if (!context)
    throw new Error("useCurrency must be used within CurrencyContextProvider");

  return context;
}
